import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Button, Flex, message, Modal } from 'antd'
import { BoosterProgramItem } from 'Modules'

import { BOOSTER_PROGRAM_MESSAGES } from 'constants/booster-program'
import { useDeleteBoosterProgram } from 'hooks/booster-program'

interface DeleteProgramModalProps {
  open: boolean
  program: BoosterProgramItem | null
  onClose: () => void
}

export const DeleteProgramModal = ({ open, program, onClose }: DeleteProgramModalProps) => {
  const deleteProgram = useDeleteBoosterProgram()
  const loading = deleteProgram.isPending

  const handleDelete = async () => {
    if (!program) return
    try {
      await deleteProgram.mutateAsync(program.id)
      message.success(BOOSTER_PROGRAM_MESSAGES.S03)
      onClose()
    } catch (e: any) {
      message.error(e?.message || 'Failed to delete booster program')
    }
  }

  return (
    <Modal
      open={open}
      title={
        <Flex gap={8} align="start">
          <ExclamationCircleOutlined style={{ color: '#faad14', fontSize: 20, marginTop: 2 }} />
          <Flex vertical>
            <div>Delete Confirm</div>
            <div style={{ fontSize: 12, color: '#6a7282', fontWeight: 400 }}>
              This action cannot be undone
            </div>
          </Flex>
        </Flex>
      }
      onCancel={onClose}
      closable={!loading}
      maskClosable={!loading}
      centered
      destroyOnClose
      footer={() => (
        <>
          <Button disabled={loading} onClick={onClose}>
            Cancel
          </Button>
          <Button color="danger" variant="solid" loading={loading} onClick={handleDelete}>
            Delete
          </Button>
        </>
      )}
    >
      Are you sure you want to delete this booster program? All associated data will be permanently
      removed from the system.
    </Modal>
  )
}
